export enum CacheStatus {
  BEHIND = 'BEHIND',
  FETCHING = 'FETCHING',
  CACHED = 'CACHED',
  ERRORED = 'ERRORED'
}
